import { State } from "./state"

export class Versioninfo {
    public __classname__: string = 'Versioninfo';

    public Version : string | null = null
	public User: string | null = null
	public Comment: string | null = null
	public Slugline: string | null = null
	public Created: string | null = null
	public Object: string | null = null
	public State: State | null = null
	public Attachment: string | null = null

    constructor(
        Version : string | null = null,
        User: string | null = null,
        Comment: string | null = null,
        Slugline: string | null = null,
        Created: string | null = null,
        Object: string | null = null,
        State: State | null = null,
        Attachment: string | null = null
    ) {
        this.Version = Version;
        this.User = User;
        this.Comment = Comment;
        this.Slugline = Slugline;
        this.Created = Created;
        this.Object = Object;
        this.State = State;
        this.Attachment = Attachment;
    }
}